module.exports = __webpack_public_path__ + "img/restapi.7610a043.svg";